export default __webpack_public_path__ + "static/media/ge1.ec2ba53b.jpg";